module.exports = __webpack_public_path__ + "img/DaysJP.977474a7.png";